<template>
  <hm-content>
    <div class="flex flex-end">
      <div class="pointer mr10" @click="showSetting">
        <span class="hmicon icon-xitong"></span>
        注册设置
      </div>
    </div>
    <div class="table mt20">
      <el-table
        stripe
        :data="memberInfoList.records"
        style="width: 100%"
        id="table"
        size="small"
        border
      >
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="fillingKey"
          label="类型"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="fillingKeyName"
          label="基本信息"
        >
          <!-- <template slot-scope="scope">
            <span v-if="scope.row.fillingKey == 'mobile'">手机号</span>
            <span v-if="scope.row.fillingKey == 'name'">姓名</span>
            <span v-if="scope.row.fillingKey == 'birthday'">生日</span>
            <span v-if="scope.row.fillingKey == 'address'">地址</span>
            <span v-if="scope.row.fillingKey == 'family_archives'"
              >家庭档案-孕产</span
            >
            <span v-if="scope.row.fillingKey == 'email'">邮箱</span>
            <span v-if="scope.row.fillingKey == 'education'">学历</span>
            <span v-if="scope.row.fillingKey == 'id_card'">身份证号</span>
          </template> -->
        </el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="fillingStrategy"
          label="使用场景"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.fillingStrategy == 'both'"
              >注册页面,完善页面</span
            >
            <span v-if="scope.row.fillingStrategy == 'reg'">注册页面</span>
            <span v-if="scope.row.fillingStrategy == 'details'">完善页面</span>
            <span v-if="scope.row.fillingStrategy == 'none'">无</span>
            <span v-if="scope.row.fillingStrategy == null">无</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="enabledState"
          label="状态"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.enabledState == 'yes'" class="success"
              >开启</span
            >
            <span v-else class="danger">关闭</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="是否必填"
          prop="isMustWrite"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.isMustWrite == 'yes'">必填</span>
            <span v-else>非必填</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="150"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <el-tooltip class="item" content="编辑" placement="top">
              <div class="pointer mr10" @click="edit(scope.row)">
                <span class="hmicon icon-bianji blue"></span>
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="memberInfoList.total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      title="编辑"
      :visible.sync="dialogVisible"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="product-ruleForm"
      >
        <el-form-item label="类型：" prop="fillingKey">
          <el-input
            v-model="ruleForm.fillingKey"
            size="small"
            clearable
            class="mr10 ipt"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="资料项名称：" prop="fillingKeyName">
          <el-input
            v-model="ruleForm.fillingKeyName"
            size="small"
            clearable
            class="mr10 ipt"
            placeholder="请输入资料项名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="使用场景：" prop="fillingStrategy">
          <el-select
            clearable
            class="mr10 ipt"
            v-model="ruleForm.fillingStrategy"
            placeholder="请选择使用场景"
          >
            <el-option label="注册页面" value="reg"> </el-option>
            <el-option
              label="完善页面"
              value="details"
              v-if="row.fillingKey !== 'memberAddress'"
            >
            </el-option>
            <el-option
              label="注册页面,完善页面"
              value="both"
              v-if="row.fillingKey !== 'memberAddress'"
            >
            </el-option>
            <el-option label="无" value="none"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否必填：" prop="isMustWrite">
          <el-switch
            :width="30"
            :disabled="
              row.fillingKey === 'memberMobile' ||
                row.fillingKey === 'recommendMan'
            "
            active-color="#13ce66"
            v-model="ruleForm.isMustWrite"
            active-text="是"
            inactive-text="否"
            active-value="yes"
            inactive-value="no"
          ></el-switch>
          <el-select
            class="ml20 ipt"
            v-model="ruleForm.checkRuleType"
            placeholder="请选择姓名输入框限制"
            v-if="row.fillingKey === 'memberName'"
          >
            <el-option label="姓名输入框只能输入中文" value="onlyChinese"></el-option>
            <el-option label="姓名输入框默认不限制" value="-"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否启用：" prop="enabledState">
          <el-switch
            :width="30"
            active-color="#13ce66"
            v-model="ruleForm.enabledState"
            active-text="是"
            inactive-text="否"
            active-value="yes"
            inactive-value="no"
          ></el-switch>
        </el-form-item>
        <div class="flex flex-center">
          <el-button type="primary" size="small" @click="submitForm('ruleForm')"
            >提交</el-button
          >
          <el-button size="small" @click="dialogVisible = false"
            >返回</el-button
          >
        </div>
      </el-form>
    </el-dialog>
    <el-dialog
      title="基础设置"
      :visible.sync="dialogSetting"
      :close-on-click-modal="false"
    >
      <el-form
        :model="ruleFormSetting"
        :rules="ruleFormSettingRules"
        ref="ruleFormSetting"
        label-width="200px"
      >
          <el-form-item class="mb10" label="登录方式:" prop="loginMode">
            <el-checkbox-group
              v-model="ruleFormSetting.loginMode"
              @change="loginModeChange"
            >
              <el-checkbox
                v-for="(v, i) in loginModeList"
                :label="v.value"
                :key="i"
                >{{ v.name }}</el-checkbox
              >
            </el-checkbox-group>
            <div class="form-tips">至少选择1种登录方式</div>
          </el-form-item>
          <el-form-item class="mb10" label="显示返回上一页:" prop="goBackBtn">
            <el-switch
              v-model="ruleFormSetting.goBackBtn"
              active-text="开启"
              inactive-text="关闭"
              active-color="#13ce66"
              active-value="open"
              inactive-value="close"
            ></el-switch>
            <div class="form-tips">开启后登录页面显示返回上一页按钮</div>
          </el-form-item>
      </el-form>
      <div class="flex flex-center">
        <el-button type="primary" size="small" @click="submitRuleFormSetting('ruleFormSetting')"
          >保存</el-button
        >
        <el-button size="small" @click="dialogSetting = false"
          >取消</el-button
        >
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      regConfigId: "",
      dialogVisible: false,
      pageSize: 10,
      currentPage: 1,
      appellative: "",
      listHeaderImgUrl: "",
      fillingName: "",
      ruleForm: {
        fillingKeyName: "",
        fillingKey: "",
        fillingStrategy: "",
        isMustWrite: "",
        enabledState: "",
        checkRuleType: "-",
      },
      rules: {},
      row: {},
      dialogSetting: false,
      ruleFormSetting:{
        loginMode: [],
        goBackBtn: "open",
      },
      ruleFormSettingRules: {},
      loginModeList:[
        {
          name: "微信登录",
          value: "wechat",
        },
        {
          name: "手机号+验证码登录",
          value: "phone",
        }
      ]
    };
  },
  computed: mapGetters(["memberInfoList"]),
  watch: {
    "goodsCategoryList.total": {
      handler(val) {
        if (
          val == (this.currentPage - 1) * this.pageSize &&
          this.pageTotal != 0
        ) {
          this.currentPage -= 1;
        }
      },
      deep: true
    }
  },
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    queryList() {
      this.$store
        .dispatch("queryMemberInfoSettingList", {
          pageNo: this.currentPage,
          pageSize: this.pageSize
        })
        .then(res => {
          if (res.result.total === 0) {
            this.$store.dispatch("queryAllFansMgtLists").then(res => {
              if (res.code === "0") {
                this.$store.dispatch("queryMemberInfoSettingList", {
                  pageNo: this.currentPage,
                  pageSize: this.pageSize
                });
              }
            });
          }
        });
    },
    edit(row) {
      this.row = row;
      this.dialogVisible = true;
      this.regConfigId = row.regConfigId;
      this.$store
        .dispatch("detailsMemberInfo", {
          fillingKey: row.fillingKey
        })
        .then(res => {
          if (res.code == 0) {
            const result = res.result || {};
            this.listHeaderImgUrl = result.typeBackgroundImg;
            if (row.fillingKey === "memberMobile") {
              result.isMustWrite = "yes";
            }
            // if (result.fillingKey == "name") {
            //   this.fillingName = "姓名";
            // } else if (result.fillingKey == "mobile") {
            //   this.fillingName = "手机号";
            // } else if (result.fillingKey == "birthday") {
            //   this.fillingName = "生日";
            // } else if (result.fillingKey == "address") {
            //   this.fillingName = "地址";
            // } else if (result.fillingKey == "family_archives") {
            //   this.fillingName = "家庭档案-孕产";
            // } else if (result.fillingKey == "email") {
            //   this.fillingName = "邮箱";
            // } else if (result.fillingKey == "education") {
            //   this.fillingName = "学历";
            // } else if (result.fillingKey == "id_card") {
            //   this.fillingName = "身份证号";
            // }
            for (let key in result) {
              if (this.ruleForm.hasOwnProperty(key)) {
                this.ruleForm[key] = result[key];
              }
            }
          }
        });
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = this.ruleForm;
          params = Object.assign(params, {
            regConfigId: this.regConfigId
          });

          this.$store.dispatch("editMemberInfo", params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              this.dialogVisible = false;
              this.queryList();
            }
          });
        }
      });
    },
    showSetting(){
      this.dialogSetting = true;
    },
    loginModeChange(e){
      console.log(e);
    },
    async showSetting() {
      this.dialogSetting = true;
      const { result } = await this.$store.dispatch("queryByInfo", {
        textCode: "mallMpLoginConfig"
      });
      if (result && result.textContentZhCn) {
        this.ruleFormSetting = JSON.parse(result.textContentZhCn);
        this.textId = result.textId;
      }
    },
    async submitRuleFormSetting(){
      if(this.ruleFormSetting && this.ruleFormSetting.loginMode && this.ruleFormSetting.loginMode.length < 1){
        this.$message({
          message: "至少选择1种登录方式",
          type: "warning"
        });
        return;
      }
      let params = {
        textCode: "mallMpLoginConfig",
        textContentZhCn: JSON.stringify(this.ruleFormSetting),
        textName: "商城登录设置",
        textId: this.textId || null
      };
      await this.$store.dispatch("addOrUpdate", params);
      this.$message({
        type: "success",
        message: "设置成功"
      });
      this.$forceUpdate();
      this.dialogSetting = false;
    },
  }
};
</script>
<style lang="scss" scoped>
.title {
  position: relative;
  font-size: 14px;
  font-weight: bold;
  &::before {
    content: "";
    display: inline-block;
    width: 4px;
    height: 14px;
    background: rgba(229, 0, 101, 1);
    border-radius: 2px 0px 2px 0px;
    margin-right: 5px;
  }
}
</style>
